export enum StyleReviewAction {
    Approve = 'approve',
    Reject = 'reject_and_fix',
    RejectWithoutFix = 'reject_without_fix',
}

export const INAPPROPRIATE_LAYOUT_FEEDBACK_VALUE = 'Inappropriate Layout';
